import { useEffect, useState, useCallback } from "react";
import { DeviceBreakpoints } from "../utils/device";

export function useIsMobile(breakpoint = DeviceBreakpoints.MOBILE_MAX_WIDTH) {
  const getMatch = useCallback(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= breakpoint;
  }, [breakpoint]);

  const [matches, setMatches] = useState(() => getMatch());

  useEffect(() => {
    const handler = () => setMatches(getMatch());
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [getMatch]);

  return matches;
}

export function useIsMobileDefault() {
  return useIsMobile(DeviceBreakpoints.MOBILE_MAX_WIDTH);
}

